module.exports = __webpack_public_path__ + "static/media/routes04.1c54475a.webp";